import React, {useContext, useMemo, useState} from "react";
import {Page, PatientInfo} from "./types";
import {ActionContext, ActionType} from "../components/hooks/provider";
import {LangManager} from "../components/i18n/langManager";
import { openInApp } from '../bridge/bridgeHelper'

interface IProps {
    patientInfo: PatientInfo
}

export default function ContactInfo(props: IProps) {
    const [checked, setChecked] = useState<boolean | null>(null)
    const {dispatchActionState, actionState} = useContext(ActionContext)
    const [submitted, setSubmitted] = useState(false)

    const langManager = LangManager(actionState.language)
    const $title = (
        <p className={"text-black text-base font-medium leading-5"}>{`${langManager.onlineCheckin}${props.patientInfo.name}`}</p>
    )

    const $description = (
        <div className={"w-full h-max bg-[#EEF3F9] flex flex-col mt-3"}>
            <p className={"text-sm text-black leading-5"}>{langManager.contactInfoDescTitle1}</p>
            <ul className={"w-full list-inside list-disc"}>
                <li className={"text-sm text-black leading-5"}>
                    {langManager.contactInfoDescS1}
                </li>
                <li className={"text-sm text-black leading-5"}>
                    {langManager.contactInfoDescS2}
                </li>
                <li className={"text-sm text-black leading-5"}>
                    {langManager.contactInfoDescS3}
                </li>
            </ul>
        </div>
    )

    const phone = useMemo(() => {
        let prefix = "xxx-xxx-"
        const {patientInfo} = props
        if (patientInfo && patientInfo.patientMobilePhone.length) {
            prefix = prefix + patientInfo.patientMobilePhone.slice(-4)
        }
        return prefix
    }, [props.patientInfo])

    const email = useMemo(() => {
        let prefix = ""
        const {patientInfo} = props
        if (patientInfo && patientInfo.patientEMail.length) {
            let as = patientInfo.patientEMail.split("@")
            if (as.length === 2) {
                prefix = patientInfo.patientEMail[0] + "***@" + as[1]
            }
        }
        return prefix
    }, [props.patientInfo])

    const $contactInfo = (
        <div className={"w-full flex flex-col space-y-2 py-2 mt-1 border-b border-black"}>
            <p className={"text-sm text-black leading-5"}>{`${langManager.phoneNumber} ${phone}`}</p>
            <p className={"text-sm text-black leading-5"}>{`${langManager.emailAddress} ${email}`}</p>
        </div>
    )

    const errMsg = submitted && checked === null ? langManager.selectYourAnswer : ""
    const $confirmContact = (
        <div className={"w-full mt-2"}>
            <p className={"text-black text-base font-medium leading-5"}>{langManager.contactInfoTitle2}</p>
            <div className={"w-full flex flex-col space-y-4 mt-2"}>
                <div onClick={() => {
                    setChecked(true)
                }} className={"w-full h-10 rounded-xl border border-[#8698C0] flex flex-row space-x-2 items-center px-4"}>
                    <input checked={checked === true} onChange={() => {
                        setChecked(true)
                    }} type={"radio"} className={"w-5 h-5"}/>
                    <label>{langManager.yes}</label>
                </div>

                <div onClick={() => {
                    setChecked(false)
                }} className={"w-full h-10 rounded-xl border border-[#8698C0] flex flex-row space-x-2 items-center px-4"}>
                    <input checked={checked === false} onChange={() => {
                        setChecked(false)
                    }} type={"radio"} className={"w-5 h-5"}/>
                    <label>{langManager.no}</label>
                </div>
            </div>
            {errMsg.length ? <p className={"text-sm text-[#C54644]"}>{errMsg}</p> : ""}
        </div>
    )

    const onContinue = () => {
        setSubmitted(true)
        if (checked === null) {
            return
        }
        dispatchActionState({type: ActionType.page, value: checked ? (openInApp ? Page.profile : Page.birthday) : Page.verifyFailed})
    }

    const $buttons = (
        <div className={"w-full grid grid-cols-2 space-x-5 mt-6"}>
            <button type={"button"} className={" py-3 px-2 text-primary font-medium bg-white border-2 border-primary rounded-xl"}>
                {langManager.back}
            </button>

            <button type={"button"} onClick={() => {
                onContinue()
            }} className={"py-3 px-2 text-white font-medium bg-primary rounded-xl"}>
                {langManager.continue}
            </button>
        </div>
    )

    return (
        <div className={"w-full"}>
            <div className={"w-full bg-white px-5 pt-4 pb-10"}>
                {$title}
                {$description}
                {$contactInfo}
                {$confirmContact}
                {$buttons}
            </div>
        </div>
    )
}
